<template>

  <div id="app" class="app" >
    <!-- <div class="language__picker" id="language__picker">
      <label for="locale">{{ $t("homeTranslate.lang") }} :</label>
      <select v-model="locale">
        <option>en</option>
        <option>fr</option>
      </select>
    </div> -->
    <navigation :isActive="isActive" @reactiveIsActive="isActive = $event"></navigation>
    <menuItems :isActive="isActive" @reactiveIsActive="isActive = $event"></menuItems>
    <router-view></router-view>
    <footerNavigation></footerNavigation>
  </div>

</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      locale: 'fr',
      isActive: false
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  },
  methods: {},
  created() {}
}
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Raleway:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i');

  /* --- Global Styling --- */
  /* eslint-disable */

*, *::before, *::after {
  box-sizing: inherit;
  margin: 0;
  padding: 0;
}

html {
	box-sizing: border-box;
	text-size-adjust: 100%;
}

button, [type='button'], [type='reset'], [type='submit'], select {
&::-moz-focus-inner {
  padding: 0;
	border-style: none;
}
}

a {
	text-decoration: inherit;
  &:hover {
    text-decoration: none;
  }
}

:link,
:visited {
	color: inherit;
}

ul {
  list-style: none;
}

@mixin clearfix {
	&::after {
		display: table;
		clear: both;
		content: '';
	}
}

@mixin clickable {
	cursor: pointer;
	user-select: none;
}

@mixin hide-scrollbar {
	&::scrollbar {
		display: none;
	}
}

@mixin placeholder {
	&::-webkit-input-placeholder {
		@content;
  }

	&:-moz-placeholder {
		@content;
	}

	&::-moz-placeholder {
		@content;
	}

	&:-ms-input-placeholder {
		@content;
	}
}

@mixin font-asset($url) {
	src: asset-url($url + '.woff') format('woff'), asset-url($url + '.ttf') format('truetype');
}

@mixin master-media($breakpoint: 0, $range: '+') {
	@if ($breakpoint > 0) {
		@if ($range == '+') {
			@media (min-width: $breakpoint) {
				@content;
			}
		}
		@if ($range == '-') {
			@media (max-width: ($breakpoint - 1px)) {
				@content;
			}
		}
	} @else {
		@if ($range == '+') {
			@content;
		}
	}
}

@mixin media($xs: null, $sm: null, $md: null, $lg: null, $xl: null, $xxl: null) {
  @include master-media(0, $xs) { @content }
  @include master-media($screen-sm-min, $sm) { @content }
  @include master-media($screen-md-min, $md) { @content }
  @include master-media($screen-lg-min, $lg) { @content }
  @include master-media($screen-xl-min, $xl) { @content }
  @include master-media($screen-xxl-min, $xxl) { @content }
}

$screen-xs-min: 0;
$screen-sm-min: 576px;
$screen-md-min: 768px;
$screen-lg-min: 992px;
$screen-xl-min: 1200px;
$screen-xxl-min: 1440px;

$color__main: black;
$color__white: #ffffff;
$color__secondary: #003366;
$color__tertiary: #F9BD2D;

$background_gradient: linear-gradient(45deg, #003366 20%, #0b5aa9f7 65%);
$background_gradient_with_opacity: linear-gradient(45deg, rgba(#003366, 0.7) 20%, rgba(#0b5aa9f7, 0.8) 45%);
$background_gradient_with_opacity_light: linear-gradient(45deg, rgba(#003366, 0.5) 20%, rgba(#0b5aa9f7, 0.6) 45%);

$transition__main: 0.2s ease;
$transition__second: 0.3s cubic-bezier(.35,.01,.07,.68);
$transition__tertiary: 0.4s ease;
$scale: scale(1.3);
$box-shadow: 3px 3px 9px rgba(black, 0.5);
$box-shadow-focus: 2px 2px 7px rgba(black, 0.6);
$box-shadow-profile: 0px 0px 10px rgba(black, 0.5);
$box-shadow-profile-focus: 0px 0px 3px rgba(black, 0.5);

$font: 'Raleway', sans-serif;
$font__secondary: 'Lato', sans-serif;

// Typos

h1 {
  font: normal normal 400 25px/25px $font;
  letter-spacing: 1px;
  @include media($md: '+') {
    font: normal normal 400 50px/50px $font;
  }
}

h2 {
  font: normal normal 400 22px/25px $font;
  letter-spacing: 1px;
  @include media($md: '+') {
    font: normal normal 400 40px/45px $font;
  }
}

h3 {
  font: normal normal 400 18px/23px $font;
  letter-spacing: 1px;
  @include media($md: '+') {
    font: normal normal 400 25px/30px $font;
  }
}

p, li {
  font: normal normal 400 12px/18px $font;
  letter-spacing: 0.5px;
  @include media($md: '+') {
    font: normal normal 400 16px/24px $font;
    letter-spacing: 0.9px;
  }
}

.app {
  width: 100%;
  min-height: 100vh;
}

// Component transition

.fade-enter-active {
  animation: fade-in 1000ms ease-out forwards;
}
.fade-leave-active {
  animation: fade-out 1000ms ease-out forwards;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
    transform: translateY(0px);
  }
  to {
    opacity: 0;
    transform: translateY(10px);
  }
}


// Add Class On Scroll

// Header

// When class is on header, open navigation

.header.active + .header__navigation--wrap {
  .header__navigation {
    transform: translateX(0);
  }
  transform: translateX(0);
}

.language__picker {
  z-index: 5;
  position: fixed;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 13px;
  height: 40px;
  cursor: pointer;
  background: rgba($color__secondary, 0.8);
  border-bottom: 1px solid $color__white;
  border-right: 1px solid $color__white;
  border-top: 1px solid $color__white;
  transition: $transition__tertiary;
  bottom: 20px;
  left: -65px;
  box-shadow: $box-shadow;
  &:hover {
    left: -1px;
    box-shadow: $box-shadow-focus;
    &::before {
      opacity: 0;
    }
  }
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 10px;
    width: 10px;
    height: 10px;
    transform: rotate(45deg) translateY(-50%);
    border-top: 1px solid $color__white;
    border-right: 1px solid $color__white;
    transition: $transition__tertiary;
  }
  label {
    font: normal normal 300 10px/10px $font;
    color: $color__white;
    margin-right: 5px;
    letter-spacing: 0.5px;
  }
  select {
    transform: translateY(1px);
    cursor: pointer;
    color: $color__white;
    font: normal normal 300 10px/10px $font;
    text-transform: capitalize;
    letter-spacing: 1px;
    background: transparent;
    border: 0;
    appearance: none;
    border-radius: 0;
    &:focus {
      outline: none;
    }
  }
}

.header {
  z-index: 5;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0px;
  width: 100%;
  transition: $transition__tertiary;
  background: rgba($color__secondary, 0.8);
  box-shadow: $box-shadow;
  border-bottom: 1px solid $color__white;

  &__icon {
    cursor: pointer;
    transition: $transition__main;
    height: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    &:hover {
      transform: translateX(10px);
      & > span {
        pointer-events: none;
        &:first-child {
          margin-bottom: 8px;
          transform: translateX(-5px);
        }
        &:last-child {
          margin-top: 8px;
          transform: translateX(-5px);
        }
      }
    }
    &:active, &:focus {
      & > span {
        &:first-child {
          margin-bottom: 0px;
          transform: translateX(0px);
          opacity: 0;
        }
        &:last-child {
          margin-top: 0px;
          transform: translateX(0px);
          opacity: 0;
        }
      }
    }
  }
  span {
    width: 30px;
    height: 1px;
    display: block;
    background: $color__white;
    transition: $transition__main;
    &:first-child {
      margin-bottom: 5px;
    }
    &:last-child {
      margin-top: 5px;
    }
  }
  &__logo {
    transform: translateY(0.5px);
    width: 200px;
    margin-bottom: -3px;
    cursor: pointer;
    @include media($md: '+') {
      width: 230px;
      transition: $transition__tertiary;
      .lines {
        transition: $transition__tertiary;
      }
      &:hover {
        transform: translateY(3px);
        svg {
          .lines {

          }
          .lines1 {
            transform: translate(5px,5px);
          }
          .lines2 {
            transform: translate(-5px,-5px);
          }
          .text {

          }
        }
      }
    }
  }
  &__navigation--wrap {
    position: fixed;
    width: 100vw;
    min-height: 100vh;
    z-index: 6;
    color: $color__white;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $color__white;
    transform: translateX(-100vw);
    transition: $transition__tertiary;
    transition-delay: 0.1s;
    border-right: 1px solid $color__white;
  }
  &__navigation {
    position: fixed;
    width: 100vw;
    min-height: 100vh;
    z-index: 6;
    color: $color__white;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $background_gradient;
    transform: translateX(-100vw);
    transition: $transition__second;
    border-right: 1px solid $color__white;
    &--container {
      &--close {
        cursor: pointer;
        position: fixed;
        top: 20px;
        left: 20px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        transform-origin: center;
        &:hover {
          &:after {
            @include media($lg: '+') {
              transform-origin: right;
              transition: $transition__main;
              content: '';
              display: block;
              height: 1px;
              background: $color__white;
              position: absolute;
              right: -50px;
              animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
            }
          }
          &:before {
            @include media($lg: '+') {
              transform-origin: right;
              transition: $transition__main;
              font: normal normal 300 10px/10px $font;
              letter-spacing: 2px;
              content: 'Exit Menu';
              display: block;
              white-space: nowrap;
              position: absolute;
              right: -110px;
              animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
            }
          }
          span {
            &:first-child {
              transform: rotate(0deg);
            }
            &:last-child {
              margin-top: -1px;
              transform: rotate(0deg);
            }
          }
        }
        span {
          width: 20px;
          height: 1px;
          display: block;
          background: $color__white;
          transform-origin: center;
          transition: $transition__main;
          &:first-child {
            transform: rotate(45deg);
          }
          &:last-child {
            margin-top: -1px;
            transform: rotate(-45deg);
          }
        }
      }
      &--nav {
        &--list {
          display: flex;
          flex-direction: column;
          @include media($lg: '+') {
            flex-direction: row;
            flex-wrap: wrap;
            padding: 0 100px;
            max-width: 1050px;
          }
          &--items {
            font: normal normal 300 25px/25px $font;
            letter-spacing: 0.5px;
            position: relative;
            margin-bottom: 30px;
            transition: $transition__tertiary;
            @include media($lg: '+') {
              display: flex;
              width: 50%;
              margin-bottom: 50px;
              font: normal normal 400 50px/50px $font;
            }
            &:hover {
              transform: translate(10px,-5px);
              a {
                &:before {
                  @include media($lg: '+') {
                    transition: $transition__main;
                    content: '';
                    display: block;
                    width: 1px;
                    background: $color__white;
                    position: absolute;
                    left: -20px;
                    bottom: -10px;
                    animation: 0.5s ease HeaderMenuLinkEffectBefore forwards;
                  }
                }
                &:after {
                  @include media($lg: '+') {
                    transition: $transition__main;
                    content: '';
                    display: block;
                    height: 1px;
                    background: $color__white;
                    position: absolute;
                    bottom: -10px;
                    left: -20px;
                    animation: 0.5s ease HeaderMenuLinkEffectAfter forwards;
                  }
                }
              }
            }
          }
          @keyframes HeaderMenuLinkEffectBefore {
            0%   { height: 0; }
            100% { height: 40px; }
          }
          @keyframes HeaderMenuLinkEffectAfter {
            0%   { width: 0; }
            100% { width: 40px; }
          }
          @keyframes HeaderMenuLinkEffectAfter50 {
            0%   { width: 0; }
            100% { width: 50px; }
          }
          #navlist--item-1 {
            @include media($lg: '+') {
              order: 1;
            }
          }
          #navlist--item-2 {
            @include media($lg: '+') {
              order: 3;
            }
          }
          #navlist--item-3 {
            @include media($lg: '+') {
              order: 5;
            }
          }
          #navlist--item-4 {
            @include media($lg: '+') {
              order: 7;
            }
          }
          #navlist--item-5 {
            @include media($lg: '+') {
              order: 2;
            }
          }
          #navlist--item-6 {
            @include media($lg: '+') {
              order: 4;
            }
          }
          #navlist--item-7 {
            @include media($lg: '+') {
              order: 6;
            }
          }
        }
        &--contact {
          position: fixed;
          bottom: 20px;
          display: flex;
          width: 200px;
          justify-content: space-between;
          left: 50%;
          transform: translateX(-50%);
          @include media($lg: '+') {
            display: none;
          }
          svg {
            display: block;
            width: 25px;
            height: 25px;
            transition: $transition__main;
            &:hover {
              transform: $scale;
            }
          }
        }
      }
    }
  }
}

// home



.home {

  // home entry

  &__entry {
    background: $background_gradient_with_opacity;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: $color__white;
    overflow: hidden;
    &--background {
      display: none;
      @include media($md: '+') {
        display: block;
        position: absolute;
        width: calc(100% + 31px);
        top: 0;
        left: 0;
        z-index: -1;
        min-width: 1300px;
      }
    }
    &--title {
      border-left: 1px solid $color__white;
      padding-left: 15px;
      h1 {
        margin-bottom: 10px;
      }
      p {
        @include media($md: '+') {
          font: normal normal 400 18px/18px $font;
        }
      }
    }
    &--motto {
      position: absolute;
      bottom: 13px;
      right: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 235px;
      @include media($md: '+') {
        width: 320px;
      }
      p {
        font: normal normal 300 10px/10px $font;
        position: relative;
        @include media($md: '+') {
          font: normal normal 400 14px/14px $font;
        }
        &:after {
          content: '';
          width: 40px;
          height: 1px;
          background: $color__white;
          display: block;
          position: absolute;
          right: -50px;
          top: calc(50% - 0.5px);
        }
      }
      img {
        display: block;
        width: 20px;
        height: 20px;
        @include media($md: '+') {
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  // home employee highlight

  &__EmployeeHighlight {
    min-height: 100vh;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 60px 20px;
    position: relative;
    background: $color__secondary;

    @include media($lg: '+') {
      flex-direction: row;
    }

    &:after {
      content: '';
      height: 1px;
      background: $color__white;
      position: absolute;
      width: 100%;
      top: 20px;
    }

    &:before {
      content: '';
      height: 125px;
      width: 1px;
      background: $color__white;
      position: absolute;
      top: 0px;
      left: 20px;

      @include media($lg: '+') {
        left: 60px;
        height: 300px;
      }
    }

    &--content {
      margin-bottom: 60px;
      color: $color__white;
      padding: 0 20px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      text-align: justify;

      @include media($md: '+') {
        padding: 0 40px;
      }

      @include media($lg: '+') {
        margin-bottom: 0px;
        max-width: 800px;
      }

      h2 {
        margin-bottom: 20px;
        text-align: left;

        @include media($md: '+') {
          width: calc(100% - 260px);
          margin-right: 40px;
          margin-bottom: 60px;
        }
      }

      p {
        margin-bottom: 20px;
      }

      a {
        display: inline-block;
        color: $color__tertiary;
        font: normal normal 300 10px/10px $font;
        position: relative;
        transition: $transition__tertiary;

        @include media($md: '+') {
          font: normal normal 400 14px/14px $font;
        }

        &:hover {
          transform: translateX(5px);

          &:after {
            content: '';
            height: 1px;
            background: $color__tertiary;
            position: absolute;
            right: -50px;
            top: calc(50% - 0.5px);
            animation: 0.5s ease HeaderMenuLinkEffectAfter forwards;
          }
        }
      }
    }

    &--holder {
      max-width: 220px;
      position: relative;
      display: block;
      position: relative;
      width: 100%;
      transition: $transition__tertiary;

      @include media($lg: '-') {
        margin-bottom: 20px;
      }

      &:hover {
        transform: scale(0.99);

        .home__EmployeeHighlight--holder--block {
          height: 40px;
          width: 40px;
        }

        .home__EmployeeHighlight--holder--block--3 {
          box-shadow: $box-shadow-focus;
        }
      }
      
      &--block {
        transition: $transition__tertiary;
        width: 30px;
        height: 30px;
        position: absolute;

        &--1 {
          border-top: 1px solid $color__white;
          border-left: 1px solid $color__white;
          top: 20px;
          left: 20px;
          z-index: 2;
          transition: $transition__tertiary;
        }

        &--2 {
          border-bottom: 1px solid $color__white;
          border-right: 1px solid $color__white;
          bottom: 20px;
          right: 20px;
          z-index: 2;
          transition: $transition__tertiary;
        }

        &--3 {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(100% - 5px);
          box-shadow: $box-shadow;
          transition: $transition__tertiary;
        }
      }
      &--image {
        img {
          width: 100%;
        }
      }
    }
  }

  // home about

  &__about {
    min-height: 100vh;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    position: relative;

    @include media($md: '+') {
      flex-direction: row;
    }

    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      top: 20px;
    }

    &:before {
      content: '';
      height: 125px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      top: 0px;
      left: 20px;

      @include media($lg: '+') {
        left: 60px;
        height: 300px;
      }
    }

    &--content {
      margin-bottom: 60px;
      color: $color__secondary;
      padding: 0 20px;
      max-width: 400px;

      @include media($md: '+') {
        margin-bottom: 0px;
      }

      h2 {
        margin-bottom: 20px;
      }

      p {
        margin-bottom: 20px;
      }

      a {
        display: inline-block;
        color: $color__tertiary;
        font: normal normal 300 10px/10px $font;
        position: relative;
        transition: $transition__tertiary;

        @include media($md: '+') {
          font: normal normal 400 14px/14px $font;
        }

        &:hover {
          transform: translateX(5px);
          
          &:after {
            content: '';
            height: 1px;
            background: $color__tertiary;
            position: absolute;
            right: -50px;
            top: calc(50% - 0.5px);
            animation: 0.5s ease HeaderMenuLinkEffectAfter forwards;
          }
        }
      }
    }
    &--holder {
      max-width: 360px;
      position: relative;
      display: block;
      position: relative;
      width: 100%;
      transition: $transition__tertiary;
      &:hover {
        transform: scale(0.99);
        .home__about--holder--block {
          height: 40px;
          width: 40px;
        }
        .home__about--holder--block--3 {
          box-shadow: $box-shadow-focus;
        }
      }
      @include media($md: '+') {
        max-width: 500px;
      }
      &--block {
        transition: $transition__tertiary;
        width: 30px;
        height: 30px;
        position: absolute;

        &--1 {
          border-top: 1px solid $color__white;
          border-left: 1px solid $color__white;
          top: 20px;
          left: 20px;
          z-index: 2;
          transition: $transition__tertiary;
        }
        &--2 {
          border-bottom: 1px solid $color__white;
          border-right: 1px solid $color__white;
          bottom: 20px;
          right: 20px;
          z-index: 2;
          transition: $transition__tertiary;
        }
        &--3 {
          background: $background_gradient_with_opacity;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(100% - 5px);
          box-shadow: $box-shadow;
          transition: $transition__tertiary;
        }
      }
      &--image {
        img {
          width: 100%;
        }
      }
    }
  }

  // home services

  &__services {
    min-height: 100vh;
    color: $color__white;
    position: relative;
    @include media($md: '+') {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    &--wrap {
      min-height: 100vh;
      background: $background_gradient;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      padding: 20px;
      position: relative;
      box-shadow: $box-shadow;
      transition: $transition__tertiary;
      @include media($md: '+') {
        min-height: calc(100vh - 40px);
        margin: 20px;
      }
      &:hover {
        box-shadow: $box-shadow-focus;
        .home__services--block {
          width: 50px;
          height: 50px;
        }
      }
    }
    &--title {
      margin: 0 auto;
      margin-bottom: 20px;
      max-width: 400px;
      width: 100%;
      @include media($md: '+') {
        max-width: 80%;
        top: 60px;
        left: 60px;
        position: absolute;
      }
      @include media($lg: '+') {
        max-width: 60%;
      }
    }
    &--subtitle {
      margin: 0 auto;
      margin-bottom: 40px;
      max-width: 400px;
      width: 100%;
      @include media($md: '+') {
        max-width: 70%;
        top: 170px;
        left: 62px;
        position: absolute;
      }
    }
    &--link {
      display: none;
      @include media($md: '+') {
        max-width: 70%;
        top: 60px;
        left: 60px;
        position: absolute;
      }
    }
    &--serviceslist {
      display: flex;
      flex-flow: wrap;
      max-width: 400px;
      width: 100%;
      margin: 0 auto;
      @include media($md: '+') {
        max-width: 315px;
        margin-top: 100px;
      }
      li {
        width: 50%;
        margin-bottom: 15px;
        cursor: pointer;
        color: $color__tertiary;
        @include media($md: '+') {
        color: $color__white;
        width: 100%;
        font: normal normal 400 20px/26px $font;
        margin-bottom: 20px;
        transition: $transition__tertiary;
          &:hover {
            transform: translateX(5px);
            span {
              display: inline-block;
              &:after {
                content: '';
                height: 1px;
                background: $color__white;
                position: absolute;
                right: -55px;
                top: calc(50% - 0.5px);
                animation: 0.5s ease HeaderMenuLinkEffectAfter forwards;
              }
              &:before {
                transform-origin: right;
                transition: $transition__main;
                font: normal normal 300 10px/10px $font;
                letter-spacing: 2px;
                content: 'Details';
                display: block;
                white-space: nowrap;
                position: absolute;
                right: -110px;
                top: 50%;
                transform: translateY(-50%);
                animation: 0.5s ease HeaderMenuLinkEffectAfter forwards;
              }
            }
          }
          span {
            position: relative;
          }
        }
      }
    }
    &--block {
      position: absolute;
      width: 30px;
      height: 30px;
      transition: $transition__tertiary;
      &--1 {
        border-top: 1px solid $color__white;
        border-left: 1px solid $color__white;
        top: 20px;
        left: 20px;
      }
      &--2 {
        border-bottom: 1px solid $color__white;
        border-right: 1px solid $color__white;
        bottom: 20px;
        right: 20px;
      }
    }
    &--link {
      margin: 0 auto;
      margin-top: 20px;
      font: normal normal 300 10px/10px $font;
      position: relative;
      color: $color__tertiary;
      max-width: 400px;
      width: 100%;
      @include media($md: '+') {
        font: normal normal 400 14px/14px $font;
        position: absolute;
        bottom: 20px;
        left: 20px;
        max-width: 110px;
        margin: 0;
      }
      &:hover {
        &:after {
          content: '';
          height: 1px;
          background: $color__tertiary;
          position: absolute;
          right: -50px;
          top: calc(50% - 0.5px);
          animation: 0.5s ease HeaderMenuLinkEffectAfter forwards;
        }
      }
    }
  }

  // home team

  &__team {
    position: relative;
    @include media($lg: '+') {
      padding-bottom: 60px;
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      top: 20px;
      left: 0;
    }
    &:before {
      content: '';
      height: 225px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      top: 0px;
      right: 20px;
      @include media($lg: '+') {
        top: -20px;
        left: 60px;
        height: 125px;
      }
    }
    &--title {
      text-align: center;
      padding-top: 60px;
      margin-bottom: 40px;
      @include media($lg: '+') {
        text-align: left;
        padding-left: 80px;
      }
    }
    &--link {
        display: none;
        @include media($lg: '+') {
          display: block;
          font: normal normal 400 14px/14px $font;
          position: absolute;
          bottom: 20px;
          left: 20px;
          max-width: 110px;
          margin: 0;
          color: $color__tertiary;
          transition: $transition__tertiary;
        }
        &:hover {
          transform: translateX(5px);
          &:after {
            content: '';
            height: 1px;
            background: $color__tertiary;
            position: absolute;
            right: -50px;
            top: calc(50% - 0.5px);
            animation: 0.5s ease HeaderMenuLinkEffectAfter forwards;
          }
        }
    }
    &--content {
      @include media($lg: '+') {
        display: flex;
        flex-flow: wrap;
        max-width: 800px;
        margin: 0 auto;
      }
      &--link {
        
        @include media($lg: '+') {
          width: 50%;
          cursor: pointer;
          margin-bottom: 0;
        }
      }
      &--profile {
        text-align: center;
        width: 240px;
        margin: 0 auto 60px;
        @include media($lg: '+') {
          margin-bottom: 30px;
          &:hover {
            .home__team--content--profile--photo--text--desktop {
              opacity: 1;
            }
            .home__team--content--profile--name {
              opacity: 1;
              position: relative;
              transform: translateY(0);
              &:before {
                content: '';
                width: 1px;
                background: $color__secondary;
                position: absolute;
                top: -40px;
                max-height: 30px;
                right: 50%;
                animation: 0.5s ease HeaderMenuLinkEffectBefore forwards;
              }
            }
            .home__team--content--profile--photo--text--desktop {
              top: 52%;
              font: normal normal 400 18px/18px $font;
            }
          }
        }
        &--photo {
          display: block;
          margin: 0 auto;
          position: relative;
          height: 240px;
          border-radius: 100%;
          overflow: hidden;
          margin-bottom: 20px;
          transition: $transition__tertiary;
          img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width:105%;
          }
          &--text {
            position: absolute;
            bottom: 0;
            color: $color__tertiary;

            &--desktop {
              display: none;
              @include media($lg: '+') {
                transform-origin: center;
                transition: $transition__tertiary;
                opacity: 0;
                display: block;
                font: normal normal 400 20px/26px $font;
                white-space: nowrap;
                letter-spacing: 0.5px;
                top: 48%;
                left: 50%;
                color: $color__white;
                position: absolute;
                transform: translate(-50%,-50%);
              }
            }
            &--mobile {
              display: block;
              font: normal normal 400 12px/12px $font;
              color: $color__tertiary;
              letter-spacing: 1px;
              width: 150px;
              margin: 0 auto;
              text-align: left;
              margin-top: 20px;
              position: relative;
              @include media($lg: '+') {
                display: none;
              }
              &:after {
                content: '';
                height: 1px;
                background: $color__tertiary;
                position: absolute;
                width: 40px;
                right: 0px;
                top: calc(50% - 0.5px);
              }
            }
          }
        }
        &--name {
          @include media($lg: '+') {
            transition: $transition__tertiary;
            opacity: 0;
            margin-top: 60px;
            transform: translateY(5px);
          }
          p {
            font: normal normal 500 14px/14px $font;
            margin-bottom: 5px;
          }
          span {
            font: normal normal 400 12px/12px $font;
          }
        }
      }
    }
  }
}

// footer

.footer {
  background: $background_gradient;
  color: $color__white;
  padding: 16.5%;
  position: relative;
  padding-bottom: 20px;
  @include media($lg: '+') {
    padding: 60px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &:after {
      content: '';
      height: 1px;
      background: $color__white;
      position: absolute;
      width: 100%;
      bottom: 30px;
      left: 0;
    }
    &:before {
      content: '';
      height: 100%;
      width: 1px;
      background: $color__white;
      position: absolute;
      top: 0px;
      right: 30px;
    }
  }
  &__block {
    width: 30px;
    height: 30px;
    position: absolute;
    @include media($lg: '+') {
      display: none;
    }
    &--1 {
      border-top: 1px solid $color__white;
      border-left: 1px solid $color__white;
      top: 20px;
      left: 20px;
      z-index: 2;
    }
    &--2 {
      border-bottom: 1px solid $color__white;
      border-right: 1px solid $color__white;
      bottom: 20px;
      right: 20px;
      z-index: 2;
    }
    &--3 {
      background: $background_gradient_with_opacity;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 5px);
      box-shadow: $box-shadow;
    }
  }

  &__navigation {
    &--list {
      margin-bottom: 20px;
      &--item {
        margin-bottom: 10px;
        @include media($lg: '+') {
          font: normal normal 400 14px/14px $font;
          position: relative;
          cursor: pointer;
          transition: $transition__tertiary;
          &:hover {
            transform: translateX(5px);
          }
        }
      }
    }
  }
  &__contact {

    @include media($lg: '+') {
      max-width: 400px;    
    }

    &--list {
      margin-bottom: 20px;
      @include media($lg: '+') {
        margin-left: -7px;
      }
      &--item {
        @include media($lg: '+') {
          font: normal normal 400 14px/14px $font;
          &:hover {
            span {
              transform: translateX(5px);
            }
            svg {
              transform: $scale;
            }
          }
        }
        a {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          &.footer_address {
            flex-wrap: wrap;
            
            span {
              width: auto;

              &:first-of-type {
                width: 320px;

                @include media($lg: '-') {
                  width: 180px;
                }
              }

              &:last-of-type {
                margin-top: 10px;
                font-size: 10px;
              }
            }
          }

          svg {
            transition: $transition__main;
            width: 25px;
            height: 25px;
          }

          span {
            transition: $transition__main;
            margin-left: 10px;
            display: block;
          }
        }
        &.business-hours {
          svg {
            width: 20px;
            height: 20px;
            margin-left: 5px;
          }
        }
      }
    }
    &--list--hours {
      margin-bottom: 40px;

      &--item {
        display: flex;
        margin-bottom: 10px;
        transition: $transition__tertiary;

        @include media($lg: '+') {
          font: normal normal 400 14px/14px $font;

          &:hover {
            transform: translateX(5px);

            span:first-child {

              &:before {
                width: 20px;
              }
            }
          }
        }

        span {

          &:first-child {
            display: block;
            width: 20px;
            margin-right: 60px;
            position: relative;
            transition: $transition__tertiary;

            &:before {
              transition: $transition__tertiary;
              content: '';
              width: 40px;
              height: 1px;
              background: $color__white;
              position: absolute;
              top: 50%;
              max-height: 30px;
              right: -45px;
            }
          }
          &:last-child {

          }
        }
      }

      &--specification {
        font-size: 10px;
        width: 200px;
        display: block;
        line-height: 1.3;
      }
    }
  }
  &__social {
    text-align: center;
    @include media($lg: '+') {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    a {
      svg {
        width: 25px;
        height: 25px;
        transition: $transition__main;
        &:hover {
          transform: $scale;
        }
      }
    }
  }
  &__logo {
    max-width: 200px;
    margin: 0 auto;
    margin-bottom: -10px;
    transition: $transition__tertiary;
    &:hover {
      transform: translateY(-5px);
      svg {
        .lines {

        }
        .lines1 {
          transform: translate(5px,5px);
        }
        .lines2 {
          transform: translate(-5px,-5px);
        }
        .text {

        }
      }
    }
    polyline {
      display: none;
      transition: $transition__tertiary;
    }
    .text {
      transition: $transition__tertiary;
    }
    @include media($lg: '+') {
      position: absolute;
      bottom: 60px;
      right: 60px;
      width: 100%;
      polyline {
        display: block;
      }
    }
  }
  &__copyright {
    text-align: center;
    font: normal normal 300 10px/10px $font;
    @include media($lg: '+') {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

// about

.about {

  // about entry

  &__entry {
    padding: 60px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    @include media($md: '-') {
      padding-top: 110px;
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      bottom: 20px;
      left: 0;
      @include media($md: '+') {
        display: none;
      }
    }
    &:before {
      content: '';
      height: 200px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      bottom: 0px;
      left: 20px;
      @include media($md: '+') {
        display: none;
      }
    }
    &--content {
      max-width: 400px;
      margin: 0 auto;
      text-align: justify;
      @include media($md: '+') {
        max-width: 550px;
      }
      &--title {
        margin-bottom: 30px;
      }
      &--body {
        &--second {
          @include media($md: '-') {
            display: none;
          }
        }
      }
    }
    &--anchor-list {
      display: none;
      @include media($md: '+') {
        cursor: pointer;
        position: fixed;
        top: 50%;
        right: 0px;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        z-index: 5;
        color: $color__white;
        background: rgba($color__secondary, 0.8);
        padding: 10px 20px;
        padding-right: 30px;
        border: 1px solid $color__white;
        border-right: 0px;
        box-shadow: $box-shadow;
        transition: $transition__tertiary;
        margin-right: -10px;
        &:hover {
          margin-right: 0px;
        }
      }
      a {
        font: normal normal 400 12px/12px $font;
        transition: $transition__tertiary;
        position: relative;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }

  // about history

  &__history {
    background: $background_gradient_with_opacity;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: $color__white;
    overflow: hidden;
    padding: 40px;
    transition: $transition__tertiary;
    &:hover {
      .about__history--block {
        width: 40px;
        height: 40px;
      }
    }
    &--block {
      transition: $transition__tertiary;
      width: 30px;
      height: 30px;
      position: absolute;

      &--1 {
        border-top: 1px solid $color__white;
        border-left: 1px solid $color__white;
        top: 20px;
        left: 20px;
        z-index: 2;
      }
      &--2 {
        border-bottom: 1px solid $color__white;
        border-right: 1px solid $color__white;
        bottom: 20px;
        right: 20px;
        z-index: 2;
        @include media($sm: '-') {
          right: 40px;
        }
      }
    }
    &--background {
      display: none;
      @include media($md: '+') {
        display: block;
        position: absolute;
        width: calc(100% + 31px);
        top: 0;
        left: 0;
        z-index: -1;
        min-width: 1300px;
      }
    }
    &--content {
      max-width: 400px;
    }
    &--title {
      border-left: 1px solid $color__white;
      padding-left: 15px;
      margin-bottom: 30px;
      @include media($md: '+') {
        border-left: 0px;
        margin: 0;
      }
      h2 {
        margin-bottom: 5px;
        @include media($md: '+') {
          position: absolute;
          top: 60px;
          left: 60px;
        }
      }
      p {
        position: relative;
        @include media($md: '+') {
          font: normal normal 400 18px/18px $font;
          position: absolute;
          top: 70px;
          right: 60px;
          &:after {
            content: '';
            width: 40px;
            height: 1px;
            background: $color__white;
            display: block;
            position: absolute;
            left: -50px;
            top: 50%;
          }
        }
      }
    }
    &--body {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      text-align: justify;
      @include media($md: '+') {
        padding: 0;
      }
      p {
        font: normal normal 300 10px/10px $font;
        @include media($md: '+') {
          font: normal normal 400 14px/14px $font;
        }
      }
      img {
        display: block;
        width: 20px;
        height: 20px;
        @include media($md: '+') {
          width: 30px;
          height: 30px;
        }
      }
    }
  }

  &__next-page {
    padding: 40px;
    min-height: 200px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    cursor: pointer;
    @include media($sm: '+') {
      justify-content: center;
      min-height: 400px;
      &:hover {
        .about__next-page--title {
          transform: translateX(-10px);
          &:after {
            content: '';
            height: 1px;
            background: $color__secondary;
            display: block;
            position: absolute;
            right: -60px;
            top: 50%;
            animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
          }
        }
      }
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      top: 20px;
      left: 0;
    }
    &:before {
      content: '';
      height: 300px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      bottom: 0px;
      right: 20px;
      @include media($md: '+') {
        right: initial;
        bottom: initial;
        left: 60px;
        top: 0;
      }
    }
    &--title {
      font: normal normal 400 22px/22px $font;
      position: relative;
      max-width: 150px;
      @include media($sm: '+') {
        max-width: 100%;
      }
      &:after {
        content: '';
        height: 1px;
        width: 40px;
        background: $color__secondary;
        display: block;
        position: absolute;
        right: -50px;
        top: 55%;
        @include media($sm: '+') {
          display: none;
        }
      }
      @include media($md: '+') {
        font: normal normal 400 40px/40px $font;
        transition: $transition__tertiary;
      }
    }
  }

}

// services

// services entry

.services {
  &__entry {
    background: $background_gradient_with_opacity;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    color: $color__white;
    overflow: hidden;
    padding: 60px;
    &--background {
      display: none;
      @include media($md: '+') {
        display: block;
        position: absolute;
        width: calc(100% + 31px);
        top: 0;
        left: 0;
        z-index: -1;
        min-width: 1300px;
      }
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__white;
      position: absolute;
      width: 100%;
      bottom: 20px;
      left: 0;
      @include media($md: '+') {
        display: none;
      }
    }
    &:before {
      content: '';
      height: 200px;
      width: 1px;
      background: $color__white;
      position: absolute;
      bottom: 0px;
      left: 20px;
      @include media($md: '+') {
        display: none;
      }
    }
    &--content {
      max-width: 400px;
      margin: 0 auto;
      &--title {
        color: $color__white;
        margin-bottom: 30px;
      }
    }
    &--anchor-list {
      display: none;
      @include media($lg: '+') {
        max-width: 125px;
        cursor: pointer;
        position: fixed;
        top: 50%;
        left: 0px;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        z-index: 5;
        padding: 10px 20px;
        background: rgba($color__secondary, 0.8);
        padding-left: 30px;
        margin-left: -110px;
        transition: $transition__tertiary;
        border: 1px solid $color__white;
        border-left: 0px;
        box-shadow: $box-shadow;
        &:hover {
          margin: 0;
          &::before {
            opacity: 0;
          }
        }
      }
      a {
        color: $color__white;
        font: normal normal 400 12px/15px $font;
        transition: $transition__tertiary;
        position: relative;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        right: 9px;
        width: 10px;
        height: 10px;
        transform: rotate(45deg) translateY(-50%);
        border-top: 1px solid $color__white;
        border-right: 1px solid $color__white;
        transition: $transition__tertiary;
      }
    }
  }

  // services variant 1

  &__variant--wrapper {
    @include media($lg: '+') {
      position: relative;
      &:after {
        content: '';
        height: 300px;
        background: $color__secondary;
        position: absolute;
        width: 1px;
        top: 0px;
        right: 20px;
      }
      &:before {
        content: '';
        height: 1px;
        width: 100%;
        background: $color__secondary;
        position: absolute;
        top: 20px;
        right: 0px;
      }
    }
  }

  &__variant {
    padding: 40px;
    position: relative;
    padding-bottom: 60px;
    @include media($md: '+') {
      max-width: 500px;
      margin: 0 auto;
      padding-top: 60px;
      padding-bottom: 60px;
    }
    @include media($lg: '+') {
      padding: 60px;
      max-width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      max-width: 1200px;
      min-height: 100vh;
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      bottom: 20px;
      left: 0;
      @include media($md: '+') {
        display: none;
      }
    }
    &:before {
      content: '';
      height: 200px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      bottom: 0px;
      right: 20px;
      @include media($md: '+') {
        display: none;
      }
    }
    &--header {
      @include media($lg: '+') {
        min-width: 300px;
      }
      &--title {
        margin-bottom: 20px;
      }
      &--body {
        @include media($lg: '+') {
          font: normal normal 500 20px/26px $font;
        }
      }
      &--link {
        display: none;
        @include media($lg: '+') {
          font: normal normal 400 14px/14px $font;
          margin-top: 20px;
          display: inline-block;
          position: relative;
          transition: $transition__tertiary;
          cursor: pointer;
          color: $color__tertiary;
          &:hover {
            transform: translateX(5px);
            &:after {
              content: '';
              height: 1px;
              background: $color__tertiary;
              position: absolute;
              right: -60px;
              top: 50%;
              animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
            }
          }
        }
      }
    }
    &--body {
      @include media($lg: '+') {
        background: $background_gradient;
        box-shadow: $box-shadow;
        color: $color__white;
        padding: 60px 110px 60px 90px;
        margin-left: 60px;
        position: relative;
        transition: $transition__tertiary;
        &:hover {
          box-shadow: $box-shadow-focus;
          transform: scale(0.99);
          .services__variant--body--block {
            width: 40px;
            height: 40px;
          }
        }
      }
      &--block {
        @include media($lg: '+') {
          display: block;
          position: absolute;
          display: block;
          width: 30px;
          height: 30px;
          transition: $transition__tertiary;
          &--1 {
            border-top: 1px solid $color__white;
            border-left: 1px solid $color__white;
            top: 20px;
            left: 20px;
          }
          &--2 {
            border-bottom: 1px solid $color__white;
            border-right: 1px solid $color__white;
            bottom: 20px;
            right: 20px;
          }
        }
      }
      &--step {
        &--1, &--2, &--3, &--4, &--5, &--6 {
          &:hover {
            .services__variant--body--step--title {
              transform: translate(5px);
            }
            .services__variant--body--step--title:after {
              width: 50px;
              right: -70px;
              @include media($sm: '-') {
                right: -50px;
                width: 30px;
              }
            }
          }
        }
        margin-top: 30px;
        @include media($md: '+') {
          margin-top: 40px;
        }
        @include media($lg: '+') {
          margin-top: 0px;
          &:not(:first-child) {
            margin-top: 40px;
          }
        }
        &--title {
          font: normal normal 500 16px/22px $font;
          margin-bottom: 20px;
          position: relative;
          display: inline-block;
          transition: $transition__tertiary;
          @include media($md: '-') {
            max-width: 250px;
          }
          @include media($sm: '-') {
            max-width: 200px;
          }
          @include media($md: '+') {
            font: normal normal 500 20px/26px $font;
          }
          &:after {
            content: '';
            width: 40px;
            height: 1px;
            transition: $transition__tertiary;
            background: $color__secondary;
            position: absolute;
            right: -60px;
            top: 50%;
            @include media($lg: '+') {
              background: $color__white;
            }
            @include media($sm: '-') {
              width: 20px;
              right: -40px;
            }
          }
        }
        &--excerpt {
          margin-bottom: 10px;
          @include media($md: '+') {
            margin-bottom: 30px;
          }
          @include media($lg: '+') {
            display: none;
          }
        }
        &--link {
          font: normal normal 500 12px/12px $font;
          position: relative;
          cursor: pointer;
          display: inline-block;
          transition: $transition__tertiary;
          @include media($md: '+') {
            font: normal normal 500 16px/16px $font;
          }
          @include media($lg: '+') {
            display: none;
          }
          &:hover, &:focus, &:active {
            transform: translateX(5px);
            &:after {
              transform: rotate(90deg);
            }
            &:before {
              transform: rotate(180deg);
            }
          }
          &:after {
            content: '';
            height: 1px;
            transition: $transition__tertiary;
            transform-origin: center;
            background: $color__secondary;
            position: absolute;
            width: 10px;
            top: 6px;
            right: -24px;
            @include media($lg: '+') {
              display: none;
            }
          }
          &:before {
            content: '';
            width: 10px;
            height: 1px;
            transition: $transition__tertiary;
            transform-origin: center;
            transform: rotate(90deg);
            background: $color__secondary;
            position: absolute;
            top: 6px;
            right: -24px;
            @include media($lg: '+') {
              display: none;
            }
          }
        }
        &--body {
          margin-top: 10px;
          padding-left: 5px;
          opacity: 0;
          visibility: hidden;
          position: absolute;
          transition: $transition__tertiary;
          transform: translateY(5px);
          @include media($lg: '+') {
            display: block !important;
            opacity: initial;
            visibility: initial;
            position: initial;
          }
        }
        &--body.active {
          opacity: 1;
          visibility: visible;
          position: initial;
          transform: translateY(0);
        }
      }
    }
  }

  // service variant 2

  &__variant--wrapper--2 {
    background: $background_gradient;
    @include media($md: '+') {
      margin: 20px;
      box-shadow: $box-shadow;
    }
    @include media($lg: '+') {
      position: relative;
      &:after {
        display: none;
      }
      &:before {
        display: none;
      }
    }
  }

  &__variant--2 {
    color: $color__white;
    position: initial;
    @include media($md: '+') {
      max-width: 100%;

    }
    @include media($lg: '+') {
      align-items: flex-start;
      padding: 80px;
      max-width: 1200px;
    }
    &:after {
      display: none;
    }
    &:before {
      display: none;
    }
    .services__variant--header {
      &--link {
        position: absolute;
        bottom: 80px;
        color: $color__tertiary;
        &:after {
          background: $color__tertiary;
        }
      }
    }
    .services__variant--body {
      @include media($lg: '+') {
        position: relative;
        box-shadow: none;
        background: transparent;
        position: initial;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-self: flex-end;
        &:hover {
          box-shadow: none;
          transform: none;
          .services__variant--body--block {
            width: 40px;
            height: 40px;
          }
        }
      }
      @include media($xl: '+') {
        margin-left: 200px;
      }
      &--block {
        display: block;
        position: absolute;
        width: 30px;
        height: 30px;
        transition: $transition__tertiary;
        @include media($lg: '-') {
          display: none;
        }
        &--1 {
          border-top: 1px solid $color__white;
          border-left: 1px solid $color__white;
          top: 20px;
          left: 20px;
        }
        &--2 {
          border-bottom: 1px solid $color__white;
          border-right: 1px solid $color__white;
          bottom: 20px;
          right: 20px;
        }
      }
      &--step {
        &--title, &--link {
          &::after {
            @include media($lg: '-') {
              background: $color__white;
            }
          }
          &::before {
            @include media($lg: '-') {
              background: $color__white;
            }
          }
        }
      }
    }
  }

  // service variant 3

  &__variant--wrapper--3 {
    @include media($md: '+') {
    }
    @include media($lg: '+') {
      background: $background_gradient_with_opacity;
      min-height: 100vh;
      position: relative;
      overflow: hidden;
      &:after {
        @include media($lg: '+') {
          background: $color__white;
        }
      }
      &:before {
        @include media($lg: '+') {
          background: $color__white;
        }
      }
    }
    .services__variant--wrapper--background {
      display: none;
      @include media($lg: '+') {
        display: block;
        position: absolute;
        width: calc(100% + 31px);
        top: 0;
        left: 0;
        z-index: -1;
        min-width: 1300px;
      }
    }
  }

  &__variant--3 {
    @include media($lg: '+') {
      flex-direction: column;
    }
    .services__variant--header {
      @include media($lg: '+') {
        display: flex;
        justify-content: space-between;
        width: 100%;
        color: $color__white;
      }
      &--body {
        @include media($lg: '+') {
          max-width: 500px;
        }
      }
      &--link {
        @include media($lg: '+') {
          position: absolute;
          bottom: 80px;
          right: 80px;
        }
      }
    }
    .services__variant--body {
      @include media($lg: '+') {
        margin-left: 0;
        margin-right: 80px;
        box-shadow: none;
        background: transparent;
        padding: 0;
        max-width: 500px;
        margin-right: auto;
      }
      &--block {
        @include media($lg: '+') {
          display: none;
        }
      }
    }
  }

  // service variant 4

  &__variant--wrapper--4 {

    color: $color__white;
    position: relative;
    @include media($lg: '-') {
      background: $background_gradient;
    }
  }

  &__variant--4 {
    position: initial;
    &:after {
      display: none;
    }
    &:before {
      display: none;
    }
    .services__variant--header {
      &--title {
        @include media($lg: '+') {
          color: $color__secondary;
        }
      }
      &--body {
        @include media($lg: '+') {
          color: $color__secondary;
        }
      }
    }
    .services__variant--body {
      &--block {
        position: absolute;
        width: 40px;
        height: 40px;
        &--1 {
          border-top: 1px solid $color__white;
          border-left: 1px solid $color__white;
          top: 20px;
          left: 20px;
        }
        &--2 {
          border-bottom: 1px solid $color__white;
          border-right: 1px solid $color__white;
          bottom: 20px;
          right: 20px;
        }
      }
      &--step {
        &--title, &--link {
          &::after {
            @include media($lg: '-') {
              background: $color__white;
            }
          }
          &::before {
            @include media($lg: '-') {
              background: $color__white;
            }
          }
        }
      }
    }
  }

  // service variant 5

  &__variant--wrapper--5 {
    @include media($md: '-') {
      background: $color__white;
    }
    @include media($lg: '+') {
      position: relative;
    }
  }

  &__variant--5 {
    @include media($md: '-') {
      color: $color__secondary;
    }
    .services__variant--body {
      &--block {
        @include media($lg: '-') {
          display: none;
        }
      }
      &--step {
        &--title {
          &:after {
            @include media($md: '-') {
              background: $color__secondary;
            }
          }
        }
        &--link {
          &:after {
            @include media($md: '-') {
              background: $color__secondary;
            }
          }
          &:before {
            @include media($md: '-') {
              background: $color__secondary;
            }
          }
        }
      }
    }
  }

  // service variant 6

  &__variant--wrapper--6 {
    @include media($md: '-') {
      background: $background_gradient;
      color: $color__white;
    }
  }

  &__variant--6 {
    &:after {
      @include media($md: '-') {
        background: $color__white;
      }
    }
    &:before {
      @include media($md: '-') {
        background: $color__white;
      }
    }
    .services__variant--body {
      &--step {
        &--title {
          &:after {
            @include media($md: '-') {
              background: $color__white;
            }
          }
        }
        &--link {
          &:hover, &:focus, &:active {
          }
          &:after {
            @include media($md: '-') {
              background: $color__white;
            }
          }
          &:before {
            @include media($md: '-') {
              background: $color__white;
            }
          }
        }
      }
    }
  }

  // services next page

  &__next-page {
    padding: 40px;
    min-height: 200px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    cursor: pointer;
    @include media($sm: '+') {
      justify-content: center;
      min-height: 400px;
      &:hover {
        .services__next-page--title {
          transform: translateX(-10px);
          &:after {
            content: '';
            height: 1px;
            background: $color__secondary;
            display: block;
            position: absolute;
            right: -60px;
            top: 50%;
            animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
          }
        }
      }
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      top: 20px;
      left: 0;
    }
    &:before {
      content: '';
      height: 300px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      bottom: 0px;
      right: 20px;
      z-index: -1;
      @include media($sm: '+') {
        right: initial;
        bottom: initial;
        left: 60px;
        top: 0;
      }
    }
    &--title {
      font: normal normal 400 22px/22px $font;
      position: relative;
      max-width: 150px;
      @include media($sm: '+') {
        max-width: 100%;
      }
      &:after {
        content: '';
        height: 1px;
        width: 40px;
        background: $color__secondary;
        display: block;
        position: absolute;
        right: -50px;
        top: 55%;
        @include media($sm: '+') {
          display: none;
        }
      }
      @include media($md: '+') {
        font: normal normal 400 40px/40px $font;
        transition: $transition__tertiary;
      }
    }
  }
}

// team

// team entry

.team {

  &__entry {
    color: $color__secondary;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    padding: 60px;

    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      bottom: 20px;
      left: 0;
    }

    &:before {
      content: '';
      height: 200px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      left: 20px;
      bottom: 0px;

      @include media($md: '+') {
        right: 80px;
        left: initial;
      }
    }

    &--content {
      max-width: 400px;
      margin: 0 auto;

      &--title {
        color: $color__secondary;
        margin-bottom: 30px;
      }
    }

    &--anchor-list {
      display: inline-grid;
      color: $color__secondary;
      margin-right: 24px;
      position: relative;

      @include media($md: '+') {
        cursor: pointer;
        max-width: 180px;
        position: fixed;
        top: 50%;
        left: 0px;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        z-index: 5;
        margin-left: 0px;
        background: rgba($color__secondary, 0.8);
        border: 1px solid $color__white;
        border-left: 0;
        padding: 10px 20px;
        padding-left: 30px;
        margin-left: -160px;
        transition: $transition__tertiary;
        box-shadow: $box-shadow;

        &:hover {
          margin: 0;

          &::before {
            opacity: 0;
          }
        }

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          right: 9px;
          width: 10px;
          height: 10px;
          transform: rotate(45deg) translateY(-50%);
          border-top: 1px solid $color__white;
          border-right: 1px solid $color__white;
          transition: $transition__tertiary;
        }
      }
      a {
        color: $color__white;
        font: normal normal 400 12px/12px $font;
        transition: $transition__tertiary;
        position: relative;
        @include media($md: '+') {
            font: normal normal 400 12px/12px $font;
        }
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }

  // team profile 1

  &__profile, &__profile--1 {
    background: $background_gradient;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    color: $color__white;
    overflow: hidden;
    padding: 40px;
    max-width: 1440px;
    @include media($lg: '+') {
        margin: 0 20px;
    }
    @include media($xxl: '+') {
        max-width: 1400px;
        margin: 0 auto;
    }
    &--block {
      position: absolute;
      width: 30px;
      height: 30px;
      &--1 {
        top: 20px;
        left: 20px;
        border-top: 1px solid $color__white;
        border-left: 1px solid $color__white;
      }
      &--2 {
        bottom: 20px;
        right: 20px;
        border-bottom: 1px solid $color__white;
        border-right: 1px solid $color__white;
      }
    }
    &--content {
      &--header {
        margin-bottom: 50px;
        position: relative;
        max-width: 360px;
        margin: 0 auto;
        margin-bottom: 50px;
        @include media($lg: '+') {
            margin-right: auto;
            margin-left: 100px;
        }
        @include media($xl: '+') {
            margin-left: 200px;
        }
        &:after {
          content: '';
          height: 30px;
          width: 1px;
          position: absolute;
          bottom: -40px;
          background: $color__white;
          left: 50%;
          @include media($lg: '+') {
              display: none;
          }
        }
        &--name {
          margin-bottom: 10px;
        }
        &--excerpt {

        }
      }
      &--profile {
        margin-bottom: 30px;
        position: relative;
        @include media($lg: '+') {
            position: absolute;
            right: 200px;
            &:before {
              content: '';
              width: 40px;
              height: 1px;
              background: $color__tertiary;
              left: -90px;
              top: 50%;
              position: absolute;
              display: block;
            }
        }
        &--photo {
          border-radius: 100%;
          display: flex;
          flex: 0 0 200px;
          height: 200px;
          justify-content: center;
          overflow: hidden;
          position: relative;
          width: 200px;
          border: 1px solid $color__secondary;
          box-shadow: $box-shadow-profile;
          transition: $transition__tertiary;
          &:hover {
            box-shadow: $box-shadow-profile-focus;
            transform: translateY(2px);
            .team__profile--content--profile--photo--overlay {
              opacity: 0.4;
            }
          }
          &--overlay {
            align-items: center;
            bottom: 0;
            display: flex;
            justify-content: center;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
            transition: opacity 0.25s;
            z-index: 1;
            color: $color__white;
          }
          img {
            height: 100%;
          }
        }
      }
      &--body {
        max-width: 360px;
        margin: 0 auto;
        @include media($lg: '+') {
            margin-right: auto;
            margin-left: 100px;
        }
        @include media($xl: '+') {
            margin-right: auto;
            margin-left: 200px;
        }
        &--content {
          line-height: 1.6;
          text-align: justify;
        }
        &--link {
          display: inline-block;
          margin-top: 10px;
          color: $color__tertiary;
          font: normal normal 500 12px/18px $font;
          position: relative;
          cursor: pointer;
          @include media($lg: '+') {
              max-width: 210px;
              position: absolute;
              right: 210px;
              transform: translateY(-70px);
              padding: 10px 0;
              padding-left: 10px;
              border-left: 1px solid $color__tertiary;
              transition: $transition__tertiary;
              &:hover {
                transform: translate(5px, -70px);
                padding-left: 20px;
              }
          }
          &:before {
            content: '';
            width: 30px;
            height: 1px;
            position: absolute;
            bottom: 50%;
            background: $color__tertiary;
            right: -50px;
            @include media($lg: '+') {
              display: none;
            }
          }
        }
      }
    }
  }

  // team profile 2

  &__profile--2 {
    background: $color__white;
    min-height: 100vh;
    width: 100vw;
    display: block;
    flex-direction: initial;
    justify-content: initial;
    align-items: initial;
    position: relative;
    color: initial;
    overflow: initial;
    padding: initial;
    max-width: initial;
    &:before {
      content: '';
      width: 100%;
      height: 1px;
      top: 20px;
      position: absolute;
      z-index: 2;
      background: $color__secondary;
    }
    &:after {
      display: none;
    }
    @include media($lg: '+') {
        margin: initial;
    }
    .team__profile--content {
      background: $color__white;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      color: $color__secondary;
      overflow: hidden;
      padding: 40px;
      max-width: 1440px;
      @include media($xxl: '+') {
          max-width: 1400px;
          margin: 0 auto;
      }
      &:after {
        content: '';
        width: 1px;
        height: 200px;
        top: 0;
        right: 20px;
        position: absolute;
        background: $color__secondary;
        @include media($lg: '+') {
           right: initial;
           left: 120px;
        }
      }
      &--header {
        margin-bottom: 50px;
        position: relative;
        max-width: 360px;
        margin: 0 auto;
        margin-bottom: 50px;
        @include media($lg: '+') {
            margin-right: auto;
            margin-left: 100px;
        }
        @include media($xl: '+') {
            margin-left: 200px;
        }
        &:after {
          content: '';
          height: 30px;
          width: 1px;
          position: absolute;
          bottom: -40px;
          background: $color__secondary;
          left: 50%;
          @include media($lg: '+') {
              display: none;
          }
        }
        &--name {
          margin-bottom: 10px;
        }
        &--excerpt {

        }
      }
      &--profile {
        margin-bottom: 30px;
        position: relative;
        @include media($lg: '+') {
            position: absolute;
            right: 200px;
            &:before {
              content: '';
              width: 40px;
              height: 1px;
              background: $color__tertiary;
              left: -90px;
              top: 50%;
              position: absolute;
              display: block;
            }
        }
        &--photo {
          border-radius: 100%;
          display: flex;
          flex: 0 0 200px;
          height: 200px;
          justify-content: center;
          overflow: hidden;
          position: relative;
          width: 200px;
          border: 1px solid $color__secondary;
          box-shadow: $box-shadow-profile;
          transition: $transition__tertiary;
          &:hover {
            box-shadow: $box-shadow-profile-focus;
            transform: translateY(2px);
            .team__profile--content--profile--photo--overlay {
              opacity: 0.4;
            }
          }
          &--overlay {
            align-items: center;
            bottom: 0;
            display: flex;
            justify-content: center;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
            transition: opacity 0.25s;
            z-index: 1;
            color: $color__white;
          }
          img {
            height: 100%;
          }
        }
      }
      &--body {
        max-width: 360px;
        margin: 0 auto;
        @include media($lg: '+') {
            margin-right: auto;
            margin-left: 100px;
        }
        @include media($xl: '+') {
            margin-right: auto;
            margin-left: 200px;
        }
        &--content {
          line-height: 1.6;
        }
        &--link {
          display: inline-block;
          margin-top: 10px;
          color: $color__tertiary;
          font: normal normal 500 12px/18px $font;
          position: relative;
          cursor: pointer;
          @include media($lg: '+') {
              max-width: 210px;
              position: absolute;
              right: 210px;
              transform: translateY(-70px);
              padding: 10px 0;
              padding-left: 10px;
              border-left: 1px solid $color__tertiary;
              transition: $transition__tertiary;
              &:hover {
                transform: translate(5px, -70px);
                padding-left: 20px;
              }
          }
          &:before {
            content: '';
            width: 30px;
            height: 1px;
            position: absolute;
            bottom: 50%;
            background: $color__tertiary;
            right: -50px;
            @include media($lg: '+') {
              display: none;
            }
          }
        }
      }
    }
  }

  // team next page

  &__next-page {
    padding: 40px;
    min-height: 200px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    cursor: pointer;
    @include media($sm: '+') {
      justify-content: center;
      min-height: 400px;
      &:hover {
        .team__next-page--title {
          transform: translateX(-10px);
          &:after {
            content: '';
            height: 1px;
            background: $color__secondary;
            display: block;
            position: absolute;
            right: -60px;
            top: 50%;
            animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
          }
        }
      }
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      top: 20px;
      left: 0;
    }
    &:before {
      content: '';
      height: 300px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      bottom: 0px;
      right: 20px;
      @include media($md: '+') {
        right: initial;
        bottom: initial;
        left: 60px;
        top: 0;
      }
    }
    &--title {
      font: normal normal 400 22px/22px $font;
      position: relative;
      max-width: 150px;
      @include media($sm: '+') {
        max-width: 100%;
      }
      &:after {
        content: '';
        height: 1px;
        width: 40px;
        background: $color__secondary;
        display: block;
        position: absolute;
        right: -50px;
        top: 55%;
        @include media($sm: '+') {
          display: none;
        }
      }
      @include media($md: '+') {
        font: normal normal 400 40px/40px $font;
        transition: $transition__tertiary;
      }
    }
  }
}

// resources

.resources {

  // resources entry

  &__entry {
    background: $background_gradient_with_opacity;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    color: $color__white;
    overflow: hidden;
    padding: 60px;
    &--background {
      display: none;
      @include media($md: '+') {
        display: block;
        position: absolute;
        width: calc(100% + 31px);
        top: 0;
        left: 0;
        z-index: -1;
        min-width: 1300px;
      }
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__white;
      position: absolute;
      width: 100%;
      bottom: 20px;
      left: 0;
      @include media($md: '+') {
        display: none;
      }
    }
    &:before {
      content: '';
      height: 200px;
      width: 1px;
      background: $color__white;
      position: absolute;
      bottom: 0px;
      left: 20px;
      @include media($md: '+') {
        display: none;
      }
    }
    &--content {
      max-width: 400px;
      margin: 0 auto;
      &--title {
        color: $color__white;
        margin-bottom: 30px;
        white-space: nowrap;
      }
    }
    &--anchor-list {
      display: none;
      @include media($lg: '+') {
        cursor: pointer;
        position: fixed;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        z-index: 5;
      }
      a {
        color: $color__white;
        font: normal normal 400 16px/16px $font;
        transition: $transition__tertiary;
        position: relative;
        &:hover {
          transform: translateX(-5px);
          &:before {
            content: '';
            height: 1px;
            background: $color__white;
            position: absolute;
            top: 50%;
            right: -60px;
            animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
          }
        }
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }

  // glossary

  &__glossary {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
    color: $color__secondary;
    padding: 20px;
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      top: 20px;
      left: 0;
      background: $color__secondary;
      height: 1px;
    }
    &:before {
      content: '';
      position: absolute;
      width: 1px;
      top: 0;
      left: 20px;
      background: $color__secondary;
      height: 200px;
      @include media($md: '+') {
        left: 60px;
        height: 250px;
      }
    }
    &--title {
      max-width: 400px;
      position: absolute;
      top: 20vh;
      left: 45px;
      @include media($md: '+') {
        top: 190px;
        left: 90px;
      }
    }
    &--body {
      display: flex;
      max-width: 400px;
      margin: 0 auto;
      padding: 0 20px;
      &--linklist {
        &--item {
          margin-bottom: 7px;
          position: relative;
          transition: $transition__tertiary;
          @include media($md: '+') {
            margin-bottom: 10px;
            &:hover {
              transform: translateX(-5px);
              &:after {
                content: '';
                position: absolute;
                top: 50%;
                right: -50px;
                width: 30px;
                height: 1px;
                background: $color__secondary;
                animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
              }
            }
          }
        }
      }
    }
  }

  // next page

  &__next-page {
    padding: 40px;
    min-height: 200px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    cursor: pointer;
    @include media($sm: '+') {
      justify-content: center;
    }
    @include media($md: '+') {
      min-height: 400px;
      &:hover {
        .resources__next-page--title {
          transform: translateX(-10px);
          &:after {
            content: '';
            height: 1px;
            background: $color__secondary;
            display: block;
            position: absolute;
            right: -60px;
            top: 50%;
            animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
          }
        }
      }
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      top: 0px;
      left: 0;
    }
    &:before {
      content: '';
      height: 350px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      bottom: 0px;
      right: 20px;
      @include media($md: '+') {
        right: 30px;
        height: 600px;
      }
    }
    &--title {
      font: normal normal 400 22px/22px $font;
      position: relative;
      max-width: 150px;
      @include media($sm: '+') {
        max-width: 100%;
      }
      &:after {
        content: '';
        height: 1px;
        width: 40px;
        background: $color__secondary;
        display: block;
        position: absolute;
        right: -50px;
        top: 55%;
        @include media($sm: '+') {
          display: none;
        }
      }
      @include media($md: '+') {
        font: normal normal 400 40px/40px $font;
        transition: $transition__tertiary;
      }
    }
  }
}

// faq

.faq {

  // faq entry

  &__entry {
    color: $color__secondary;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    padding: 60px;
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      bottom: 20px;
      left: 0;
    }
    &:before {
      content: '';
      height: 200px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      left: 20px;
      bottom: 0px;
      @include media($md: '+') {
        right: 80px;
        left: initial;
      }
    }
    &--content {
      max-width: 400px;
      margin: 0 auto;
      &--title {
        color: $color__secondary;
        margin-bottom: 30px;
      }
    }
    &--anchor-list {
      display: inline-grid;
      color: $color__secondary;
      margin-right: 24px;
      @include media($md: '+') {
        cursor: pointer;
        position: fixed;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        z-index: 5;
        margin-left: 0px;
      }
      a {
        color: $color__secondary;
        font: normal normal 400 12px/12px $font;
        transition: $transition__tertiary;
        position: relative;
        @include media($md: '+') {
            font: normal normal 400 16px/16px $font;
        }
        &:hover {
          transform: translateX(-5px);
          &:before {
            content: '';
            height: 1px;
            background: $color__secondary;
            position: absolute;
            top: 50%;
            right: -60px;
            animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
          }
        }
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }

  // faq questions

  &__questions {
    min-height: 100vh;
    color: $color__white;
    position: relative;
    background: $background_gradient;
    @include media($md: '+') {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    &--wrap {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      padding: 40px;
      transition: $transition__tertiary;
      padding-top: 80px;
      max-width: 400px;
      margin: 0 auto;
      @include media($md: '+') {
        padding-top: 40px;
        max-width: 450px;
      }
      &:hover {
        .home__services--block {
          width: 50px;
          height: 50px;
        }
      }
      &--question {
        position: relative;
        transition: $transition__tertiary;
        &:hover {
          transform: translateX(-10px);
          .faq__questions--wrap--question--link {
            &:after {
              @include media($md: '+') {
                animation: $transition__tertiary HeaderMenuLinkEffectAfter50 forwards;
              }
            }
          }
          .faq__questions--wrap--question--opener {
            @include media($md: '+') {
              transform: translate(0px,-50%);
              opacity: 1;
            }
          }
        }
        &--link {
          cursor: pointer;
          display: inline-block;
          margin-bottom: 100px;
          position: relative;
          @include media($md: '+') {
            margin-bottom: 30px;
            font: normal normal 400 16px/20px $font;
          }
          &:after {
            content: '';
            position: absolute;
            height: 30px;
            width: 1px;
            background: $color__white;
            left: 50%;
            top: 50px;
            transform: translateX(-50%);
            @include media($md: '+') {
              height: 1px;
              width: 0px;
              background: $color__white;
              left: initial;
              right: -50px;
              top: 15px;
              transform: translateY(-50%);
            }
          }
        }
        &--opener {
          position: absolute;
          top: 95px;
          left: 50%;
          transition: $transition__tertiary;
          transform: translateX(-50%);
          @include media($md: '+') {
            top: 15px;
            left: initial;
            right: -75px;
            transform: translate(10px,-50%);
            opacity: 0;
          }
          span {
            transition: $transition__tertiary;
            display: block;
            width: 10px;
            height: 1px;
            background: $color__white;
            transform-origin: center;
            @include media($md: '+') {
              width: 12px;
            }
          }
          span:last-child {
            transform: rotate(90deg);
            margin-top: -1px;
          }
        }
        &--opener.active {
          span {
            transform: rotate(90deg);
          }
          span:last-child {
            transform: rotate(180deg);
          }
        }
        &--body {
          opacity: 0;
          visibility: hidden;
          position: absolute;
          transition: $transition__tertiary;
          margin-bottom: 15px;
          transform: translateY(5px);
          @include media($md: '+') {
            font: normal normal 400 12px/16px $font;
          }
        }
        &--body.active {
          opacity: 1;
          visibility: visible;
          position: initial;
          transform: translateY(0);
        }
      }
    }
    &--block {
      position: absolute;
      width: 30px;
      height: 30px;
      transition: $transition__tertiary;
      &--1 {
        border-top: 1px solid $color__white;
        border-left: 1px solid $color__white;
        top: 20px;
        left: 20px;
      }
      &--2 {
        border-bottom: 1px solid $color__white;
        border-right: 1px solid $color__white;
        bottom: 20px;
        right: 20px;
      }
    }
  }

  // next page

  &__next-page {
    padding: 40px;
    min-height: 200px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    @include media($sm: '+') {
      justify-content: center;
    }
    @include media($md: '+') {
      justify-content: center;
      min-height: 400px;
    }
    &:after {
      content: '';
      height: 1px;
      background: $color__secondary;
      position: absolute;
      width: 100%;
      top: 20px;
      left: 0;
    }
    &:before {
      content: '';
      height: 200px;
      width: 1px;
      background: $color__secondary;
      position: absolute;
      bottom: 0px;
      right: 20px;
      @include media($md: '+') {
        height: 300px;
        right: initial;
        bottom: initial;
        left: 60px;
        top: 0;
      }
    }
    &--title {
      font: normal normal 400 22px/22px $font;
      position: relative;
      max-width: 150px;
      cursor: pointer;
      @include media($sm: '+') {
        max-width: 100%;
      }
      &:after {
        content: '';
        height: 1px;
        width: 40px;
        background: $color__secondary;
        display: block;
        position: absolute;
        right: -50px;
        top: 55%;
        @include media($sm: '+') {
          display: none;
        }
      }
      @include media($md: '+') {
        font: normal normal 400 40px/40px $font;
        transition: $transition__tertiary;
        &:hover {
          transform: translateX(-10px);
          &:after {
            content: '';
            height: 1px;
            background: $color__secondary;
            display: block;
            position: absolute;
            right: -60px;
            top: 50%;
            animation: $transition__tertiary HeaderMenuLinkEffectAfter forwards;
          }
        }
      }
    }
  }
}

// contact

.contact {
  padding: 40px;
  padding-top: 100px;
  min-height: 100vh;
  max-width: 400px;
  margin: 0 auto;
  @include media($md: '+') {
    padding: 80px;
    padding-top: 120px;
    max-width: 900px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__body {
    &--title {
      margin-bottom: 50px;
    }
    &--profiles {
      &--profile {
        margin-bottom: 30px;
        a {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          svg {
            transition: $transition__tertiary;
            width: 25px;
            height: 25px;
          }
          span {
            font: normal normal 500 12px/12px $font;
            transition: $transition__tertiary;
            margin-left: 10px;
          }
          &:hover {
            svg {
              transform: $scale;
            }
            span {
              transform: translateX(5px);
            }
          }
        }
        &--name {
          margin-bottom: 20px;
        }
      }
    }
  }
  &__form {
    @include media($sm: '+') {
      width: 300px;
    }
    &--container {
      border: 1px solid $color__secondary;
      &--group {
        position: relative;
        input.notempty {
          & + label {
            top: 10px;
            left: 5px;
            font: normal normal 400 10px/10px $font;
          }
        }
        input {
          height: 40px;
          border: 0px;
          border-bottom: 1px solid $color__secondary;
          width: 100%;
          padding: 0px 15px;
          padding-top: 15px;
          transition: $transition__main;
          background: transparent;
          &:focus {
            outline: none;
            & + label {
              top: 10px;
              left: 5px;
              font: normal normal 400 10px/10px $font;
            }
          }
        }
        label {
          position: absolute;
          top: 50%;
          left: 15px;
          transform: translateY(-50%);
          font: normal normal 400 12px/12px $font;
          transition: $transition__main;
          z-index: -1;
        }
        .label--textarea {
          top: 20px;
          left: 15px;
        }
        textarea {
          width: 100%;
          padding: 15px;
          transition: $transition__main;
          background: transparent;
          border: 0;
          &:focus {
            outline: none;
            & + label {
              top: 10px;
              left: 5px;
              font: normal normal 400 10px/10px $font;
            }
          }
        }
        textarea.notempty {
          & + label {
            top: 10px;
            left: 5px;
            font: normal normal 400 10px/10px $font;
          }
        }
      }
      .submit {
        height: 40px;
        border: 0px;
        background: $background_gradient;
        color: $color__white;
        width: 100%;
        font: normal normal 400 14px/14px $font;
        transition: $transition__main;
      }
      .submit:disabled {
        opacity: 0.3;
      }
    }
    &--checkbox {
      margin-top: 10px;
      font: normal normal 500 12px/12px $font;
      label {
        position: relative;
        margin-left: 30px;
        margin-top: 20px;
        display: block;
      }
      #checkbox {
        opacity: 0;
        position: absolute;
      }
      #checkbox:checked ~ span {
        background: $color__secondary;
      }
      span {
        transition: $transition__main;
        position: absolute;
        top: -5px;
        left: -30px;
        height: 20px;
        width: 20px;
        border: 1px solid $color__secondary;
      }
    }
    &--message {
      margin-top: 20px;
      cursor: pointer;

      &--opener {
        font: normal normal 700 12px/12px $font;
        margin-bottom: 10px;
        display: block;
      }

      &--terms.view-message {
        transition: $transition__tertiary;
        opacity: 1;
        position: relative;
        visibility: visible;
        transform: translateY(0px);
      }

      &--terms {
        transition: $transition__tertiary;
        opacity: 0;
        position: absolute;
        visibility: hidden;
        transform: translateY(10px);
        max-width: 300px;
      }
    }
  }
}

</style>
